const BOMConfigType = {
  NEW_CONFIG_TABS: 'NEW_CONFIG_TABS',
  DEFAULT_CONFIG_TABS: 'DEFAULT_CONFIG_TABS',
  TOOGLE_CONFIG_COMMENTS: 'TOOGLE_CONFIG_COMMENTS',
  FETCH_DEV_ORDER: 'FETCH_DEV_ORDER',
  FETCH_PRODUCT_SUGGESTION: 'FETCH_PRODUCT_SUGGESTION',
  FETCH_LIBRARY_SUGGESTION: 'FETCH_LIBRARY_SUGGESTION',
  FETCH_GROUP_SUGGESTION: 'FETCH_GROUP_SUGGESTION',
  FETCH_CARD_LIST: 'FETCH_CARD_LIST',
  ADD_CARD_LIST: 'ADD_CARD_LIST',
  FETCH_PRODUCT_DETAILS: 'FETCH_PRODUCT_DETAILS',
  FETCH_TRAFFIC_LIGHTS: 'FETCH_TRAFFIC_LIGHTS',
  CONFIG_COMMENTS: 'CONFIG_COMMENTS',
  FETCH_ORDER_PERMISSION: 'FETCH_ORDER_PERMISSION',
  UPDATE_BOM_SWITCHES: 'UPDATE_BOM_SWITCHES',
  UNMOUNT_COMPONENT: 'UNMOUNT_COMPONENT',
  ADD_CARD_LIST_BY_PAGINATION: 'ADD_CARD_LIST_BY_PAGINATION',
  TAB_SELECTION: 'TAB_SELECTION',
  BOM_SUPPLIER: 'BOM_SUPPLIER',
  SAVE_PREV_CONFIG: 'SAVE_PREV_CONFIG',
  BOM_UNMOUNT: 'BOM_UNMOUNT',
  ADD_BOM_TAG: 'ADD_BOM_TAG',
  GET_BOM_TAG: 'GET_BOM_TAG',
  GET_BOM_BYID: 'GET_BOM_BYID',
  CLEAR_BOM_REDUCER: 'CLEAR_BOM_REDUCER',
  CLEAR_BOM_CARDLIST: 'CLEAR_BOM_CARDLIST',
};

export default BOMConfigType;
